<div class="login-container">
    <div class="login-card">
        <div class="login-header">
            <img src="../../../assets/images/Logo_7MDFN_Azul_Grande.png" alt="Logo" class="login-logo" />
            <img src="../../../assets/images/logo_flor.png" alt="Logo" class="login-logo" />
        </div>

        <div class="login-welcome">
            <h2>{{'LOGIN.TITLE' | translate}}</h2>

        </div>

        <form (ngSubmit)="login()">
            <div class="form-group">
                <label>{{'LOGIN.USER' | translate}}</label>
                <div class="input-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="input-icon">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                    <input [(ngModel)]="email" name="email" type="email" [placeholder]="'LOGIN.USER_PH' | translate"
                        class="login-input" required />
                </div>
            </div>
            <div class="form-group">
                <label>{{'LOGIN.PASSWORD' | translate}}</label>
                <div class="input-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="input-icon">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                    <input [(ngModel)]="password" [name]="'password'" [type]="showPassword ? 'text' : 'password'"
                        [placeholder]="'LOGIN.PASSWORD_PH' | translate" class="login-input" required />
                    <button type="button" class="password-toggle" (click)="togglePassword()">
                        @if (showPassword) {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        } @else {
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path
                                d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
                            </path>
                            <line x1="1" y1="1" x2="23" y2="23"></line>
                        </svg>
                        }
                    </button>
                </div>
            </div>

            <button type="submit" class="login-btn" [disabled]="loading">
                @if (!loading) {
                <span>{{'LOGIN.SUBMIT' | translate}}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
                }
                @else {
                <span class="spinner"></span>
                }
            </button>

        </form>

    </div>
</div>